export const STORAGE_KEY = 'mv-VIP-id';
